<ng-template [ngIf]="isDesktop()" [ngIfElse]="mobile">
  <div class="card menu">
    <div class="card-header">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="actualSubmenu?.url || ''">
        <li ngbNavItem="'menu'" class='container-menu dropdown dropdown-toggle' id="dropdownMenu" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false" data-display="static">
          <div class="container-icon" [ngStyle]="{'background-color': actualSubmenu?.menu?.color || '#808080'}">
            <i class="container-icon-icon" [ngClass]="actualSubmenu?.menu?.icon || 'fas fa-th'"></i>
          </div>
          <!-- <span *ngIf="actualSubmenu" class='container-icon-menu'>{{actualSubmenu.menu.module.servicio}}|{{actualSubmenu.menu.nombre}}</span> -->
          <span *ngIf="!actualSubmenu" class='container-icon-menu'>¿Dónde Quiéres Ir?</span>
          <div class="dropdown-menu dropdown-menu-nav-bar" aria-labelledby="dropdownMenu">
            <app-menu-dropdown-nav-bar *ngIf="modules.length > 0" [actualSubmenu]="actualSubmenu"
              [modules]="modules"></app-menu-dropdown-nav-bar>
          </div>
        </li>
        <li *ngFor="let submenu of actualSubmenu?.menu?.sub_menu || []; let i = index" [ngbNavItem]="submenu.url">
          <a [routerLink]="submenu.url" [queryParams]="submenu.queryParams" ngbNavLink (click)="auditoria(submenu.url)">
            {{submenu.title}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #mobile>
  <div class="card menu">
    <div class="card-header">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="actualSubmenu?.url || ''">
        <li ngbNavItem="'menu'" data-toggle="collapse" href="#collapseSubmenu" role="button" aria-expanded="false"
          aria-controls="collapseSubmenu">
          <div class="container-icon" [ngStyle]="{'background-color': actualSubmenu?.menu?.color || '#808080'}">
            <i class="container-icon-icon" [ngClass]="actualSubmenu?.menu?.icon || 'fas fa-th'"></i>
          </div>
          <span *ngIf="actualSubmenu"
            class='container-icon-menu'>{{actualSubmenu.menu.module.servicio}}|{{actualSubmenu.menu.nombre}}|{{actualSubmenu.title}}</span>
          <span *ngIf="!actualSubmenu" class='container-icon-menu'>¿Dónde Quiéres Ir?</span>
        </li>
        <div #collapseSubmenuCmp class="collapse" id="collapseSubmenu">
          <app-menu-dropdown-nav-bar *ngIf="modules.length > 0" [actualSubmenu]="actualSubmenu" [modules]="modules"
            (onSubmenuRoute)="tryCollapseMobile()"></app-menu-dropdown-nav-bar>
        </div>
      </ul>
    </div>
  </div>
</ng-template>
